import { StateService } from "@uirouter/angularjs";
import { IAttributes, IAugmentedJQuery, IDirective, IDirectiveFactory, IDirectiveLinkFn, INgModelController, IScope, ITranscludeFunction } from "angular";

export class IsStateInactive implements IDirective {
  public restrict = "A";
  public transclude = this.ngIf.transclude;
  public priority = this.ngIf.priority - 1;
  public terminal = true;

  constructor(private ngIf: IDirective, private $state: StateService) {}

  public link(scope: IScope, element: IAugmentedJQuery, attrs: IAttributes, ctrl: INgModelController, transclude: ITranscludeFunction): void {
    const IsStateInactiveEvaluator = (): boolean => {
      return !this.$state.current.name.includes(attrs.isStateInactive);
    };
    const initialNgIf = attrs.ngIf;
    let ifEvaluator: () => boolean;
    if (initialNgIf) {
      ifEvaluator = () => IsStateInactiveEvaluator && scope.$eval(initialNgIf);
    } else {
      ifEvaluator = IsStateInactiveEvaluator;
    }
    attrs.ngIf = ifEvaluator;

    const ngIfLinkFn = this.ngIf.link as IDirectiveLinkFn;
    ngIfLinkFn.apply(this.ngIf, [scope, element, attrs, ctrl, transclude]);
  }

  public static factory(): IDirectiveFactory {
    const directive = (ngIfDirective: IDirective[], $state: StateService) => new IsStateInactive(ngIfDirective[0], $state);
    directive.$inject = ["ngIfDirective", "$state"];
    return directive;
  }
}
